var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');



module.exports = function () {
	function addHandlers(){

		/*anim subtitle*/
		var _viewItemHeaderContent = document.querySelector('.b4s3_home .view-item_header-content')
		;

    }

	var typeWritter = {
		elems : '',
		iT : 0,
		current : 0,
		splitedQuotes : '',
		timeout : '',
		text : '',
		elem : '',
		prev : '',
		next : '',
		init : function(){
			typeWritter.elems = document.querySelector('.b4s3_home .view-item_header-infos .grip.typeWritter');
			typeWritter.elem = typeWritter.elems;
			if(!typeWritter.elem) return; 
			typeWritter.splitedQuotes = typeWritter.elem.innerHTML.split('<br>');
			typeWritter.elem.innerHTML = '';
			typeWritter.elem.style.display = 'block';
			console.log('init');
			typeWritter.launch();
			/*Array.prototype.forEach.call(typeWritter.elems, function(el){
				typeWritter.elem = el;
				typeWritter.splitedQuotes = el.innerHTML.split('<br>');
				console.log('init');
				typeWritter.launch();
			});*/

		},
		launch : function(){

			typeWritter.iT++;
			typeWritter.text = typeWritter.splitedQuotes[typeWritter.current].slice(0, typeWritter.iT);

			typeWritter.elem.innerHTML = typeWritter.text;

			//end of type writter, add nav
			if (typeWritter.text === typeWritter.splitedQuotes[typeWritter.current]){
				typeWritter.prev = true;
				typeWritter.next = true;

				if(typeWritter.current == 0){
					typeWritter.prev = false;
				}
				if(typeWritter.current == typeWritter.splitedQuotes.length - 1){
					typeWritter.next = false;
				}
				addNav(typeWritter.prev,typeWritter.next, typeWritter);
				if(typeWritter.next){
					typeWritter.timeout = setTimeout(function(){
						//autoplay
						typeWritter.current++;
						typeWritter.iT = 0;
						//typeWritter.launch();
					}, 5000)
				}

				return;
			}
			setTimeout(function(){
				typeWritter.launch();
			}.bind(typeWritter),  Math.random() * (50 - 40) + 40);
		}
	}

	/*anim typewritter*/
	pubsub.on('endLoad', typeWritter.init); 


	//add nav
	function addNav(prev, next, typeInstance){
		if(prev){
			typeInstance.elem.innerHTML += "<span class='btnPrev'>-</span>";
			setTimeout(function(){
				document.querySelector('.btnPrev').addEventListener('click', function(){
					clearTimeout(typeInstance.timeout);
					typeInstance.current--;
					//launch
					typeInstance.iT = 0;
					typeInstance.launch();
				}); 
			}, 0);
		}
		if(next){
			typeInstance.elem.innerHTML += "<span class='btnNext'>+</span>";
			setTimeout(function(){
				document.querySelector('.btnNext').addEventListener('click', function(){
					clearTimeout(typeInstance.timeout);
					typeInstance.current++;
					//launch
					typeInstance.iT = 0;
					typeInstance.launch();
				});
			}, 0);
		}

	}

    addHandlers();


}
